import { useTranslation } from 'react-i18next';

interface HitRateGaugeProps {
  hitRate: number; // 0.0 ~ 1.0
  hitCount: number;
  missCount: number;
}

/**
 * HitRateGauge — 히트율 progress bar + 수치.
 * hitRate < 0.5 → 주황 강조 (경고).
 * design-tokens CSS var 만 사용.
 */
export function HitRateGauge({ hitRate, hitCount, missCount }: HitRateGaugeProps) {
  const { t } = useTranslation();
  const pct = Math.round(hitRate * 100);
  const isLow = hitRate < 0.5;

  const barColor = isLow
    ? 'var(--color-warning, #f59e0b)'
    : 'var(--color-success, #16a34a)';

  return (
    <div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          fontSize: 'var(--font-size-xs)',
          color: isLow ? 'var(--color-warning-text, #92400e)' : 'var(--color-text-secondary)',
          marginBottom: 4,
          fontWeight: isLow ? 700 : 400,
        }}
      >
        <span>{t('cacheAdmin.card.hitRate')}</span>
        <span>{pct}%</span>
      </div>
      <div
        role="progressbar"
        aria-valuenow={pct}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={`히트율 ${pct}%`}
        style={{
          height: 6,
          borderRadius: 'var(--radius-full, 9999px)',
          background: 'var(--color-surface-elevated)',
          overflow: 'hidden',
        }}
      >
        <div
          style={{
            height: '100%',
            width: `${pct}%`,
            background: barColor,
            borderRadius: 'var(--radius-full, 9999px)',
            transition: 'width 0.3s ease',
          }}
        />
      </div>
      <div
        style={{
          fontSize: 'var(--font-size-xs)',
          color: 'var(--color-text-muted)',
          marginTop: 2,
        }}
      >
        {hitCount.toLocaleString()} hit / {missCount.toLocaleString()} miss
      </div>
    </div>
  );
}
